<template>
  <div
    id="exhibition"
    v-if="thisShow"
    v-bind:class="thisShow.exposicao_room_number.value"
  >
    <pageHeader></pageHeader>
    <fixedHeader></fixedHeader>

    <div id="exhibition-header">
      <div class="row align-center text-center medium-collapse">
        <div class="xxlarge-10 medium-12 columns">
          <router-link
            v-if="thisShow.exposicao_room.value != 'na'"
            :to="`/sala/${thisShow.exposicao_room.value}`"
            v-bind:class="[thisShow.exposicao_room.value]"
            class="category-link"
            ><span>{{ thisShow.exposicao_room.label }}</span></router-link
          >
          <h2 class="page-title">{{ thisShow.exposicao_title }}</h2>
          <h3 v-if="thisShow.exposicao_main_author">
            {{ thisShow.exposicao_main_author }}
          </h3>
          <img v-bind:src="thisShow.exposicao_main_image.url" />
        </div>
      </div>
    </div>

    <div id="exhibition-info">
      <div class="row medium-collapse">
        <div
          class="xxlarge-6 xxlarge-offset-1 medium-7 medium-offset-0 xsmall-12 columns"
        >
          <h3 v-html="thisShow.exposicao_description"></h3>
        </div>
        <div
          class="xxlarge-3 xxlarge-offset-1 medium-4 medium-offset-1 xsmall-12 xsmall-offset-0 columns"
        >
          <ul class="technical-record">
            <li class="planta-item">
              <h4>Localização da Sala</h4>
              <svg class="planta-svg" viewBox="0 0 624 218">
                <path
                  class="ecras"
                  d="M539.5,141.5h-7v-17h7V141.5z M585.5,161.5v-7h-23v7H585.5z"
                />
                <path
                  class="lab"
                  d="M114.4 61L12.5 166.5h-.6l-1.1-1.1L111.7 61h2.7zm-15.9 0h-2.8L8 151.8v.8l1 1L98.5 61zm-18.6 0L8 135.7v2.9L82.6 61h-2.7zm-15.6 0L8 119.3v2.9L67 61h-2.7zm-15.7 0L8 103v2.9L51.4 61h-2.8zm-15.7 0L8 86.6v2.9L35.6 61h-2.7zM17 61l-9 9.6v2.9L19.8 61H17zm99 13l-.2-.2-90.7 92.7h2.8L116 76.4V74zm0 15.7l-74.7 76.8h2.8L116 92.6v-2.9zm0 16.3l-58.9 60.5h2.8l56.1-57.7V106zm0 16.2l-43.1 44.3h2.8l40.3-41.4v-2.9zm0 16.2l-27.3 28.1h2.8l24.5-25.2v-2.9z"
                />
                <path
                  class="sala-a grey"
                  d="M530.7 56l-108 111.9h-.6l-1.1-1.1L527.9 56h2.8zm-20.5 5h-2.8l-93.6 96.6v.8l1 1L510.2 61zm-18.7 0l-77.7 80.5v2.9L494.3 61h-2.8zm-15.6 0l-62.1 64.1v2.9l64.9-67h-2.8zm-15.6 0l-48.2 49.6v2.9L463 61h-2.7zm-15.8 0l-31.9 32.7v2.9L447.3 61h-2.8zm-15.8 0l-18.2 17.9v2.9L431.4 61h-2.7zm101 10.6l-.2-.2-92.7 95.1h2.8L529.7 74v-2.4zm0 15.7L453 166.5h2.8l73.9-76.3v-2.9zm0 16.2l-60.9 63h2.8l58.1-60.1v-2.9zm-.3 16.6l-44.8 46.4h2.8l42-43.6v-2.8zm0 16.2l-29 30.2h2.8l26.2-27.4v-2.8zm.2 15.5l-14.3 15.5h2.8l11.5-12.6v-2.9z"
                />
                <path
                  class="sala-b grey"
                  d="M403.8 56L297 166.8h-.6l-1.1-1.1L401 56h2.8zm-20.5 5h-2.8l-88.1 91.1v.8l1 1L383.3 61zm-18.7 0l-72.2 75v2.9l75-77.9h-2.8zM349 61l-56.6 58.6v2.9L351.8 61H349zm-15.7 0l-40.9 42.3v2.9L336.1 61h-2.8zm-15.7 0l-25.2 25.9v2.9l28-28.8h-2.8zm-15.8 0l-9.1 8.8v2.9L304.5 61h-2.7zm110.4 1.1l-.2-.2-102.2 104.6h2.8l99.6-102v-2.4zm0 15.7L326 166.5h2.8l83.4-85.8v-2.9zm0 16.2l-70.4 72.5h2.8l67.6-69.6V94zm0 16.3l-54.6 56.2h2.8l51.8-53.4v-2.8zm0 16.2l-38.8 40h2.8l36-37.2v-2.8zm.3 15.5l-24.1 25.3h2.8l21.3-22.4V142z"
                />
                <path
                  class="sala-c grey"
                  d="M296 85.2l-71.4 75h-.6l-1.1-1.1 70.3-73.9h2.8zm-3.3-12.6l.1-2.8-70.6 73.4v2.9l70.5-73.5zm-3.9-14.7L222 127.5v2.9l69.6-72.5h-2.8zm-15.6 0L222 111.1v2.9l54-56.1h-2.8zm-15.7 0l-35.5 37v2.9l38.3-39.9h-2.8zm-15.7 0L222 78.5v2.9l22.6-23.5h-2.8zm51 45.2l-.2-.2-61.7 63.6h2.8l59.1-61v-2.4zm0 15.7l-45.6 47.7h2.8l42.8-44.8v-2.9zm0 16.2L263 166.5h2.8l27.1-28.6V135zm0 16.2l-14.1 15.3h2.8l11.3-12.4v-2.9z"
                />
                <path
                  class="sala-d grey"
                  d="M225.4 61L120.5 169.4h-.6l-1.1-1.1L222.6 61h2.8zm-15.9 0h-2.8L116 154.7v.8l1 1L209.5 61zm-18.7 0L116 138.6v2.9L193.6 61h-2.8zm-15.6 0L116 122.2v2.9L178 61h-2.8zm-15.7 0L116 106v2.9L162.3 61h-2.8zm-15.7 0L116 89.6v2.9L146.6 61h-2.8zm-15.9 0L116 73.5v2.9L130.7 61h-2.8zm94.2 17.8l-.2-.2-85.9 87.9h2.8l83.3-85.2v-2.5zm0 15.8l-69.9 71.9h2.8l67.1-69.1v-2.8zm0 16.2L168 166.5h2.8l51.3-52.8v-2.9zm0 16.2l-38.3 39.5h2.8l35.5-36.6V127zm0 16.2l-22.5 23.3h2.8l19.7-20.4v-2.9z"
                />
                <path
                  class="sala-e grey"
                  d="M297.2 34.7l.1-2.8-23.9 25.2V60l23.8-25.3zm-4-14.8l-35.8 38v2.9L296 19.9h-2.8zm3.2-18.7l-51.2 53.2v2.9l54-56.1h-2.8zm-19 3.3l-41.8 43.3v2.9l44.6-46.2h-2.8zM265 1.2l-29.4 30.2v2.9l32.2-33.1H265z"
                />
                <path
                  class="q22"
                  d="M589.2 121l-1.4-1.4 21.7-22.3 1.4 1.4-21.7 22.3zm-14.8-1.5l-1.4-1.4 34.8-35.8 1.4 1.4-34.8 35.8zm-9.6-6.6l-1.4-1.4 37.8-38.8 1.4 1.4-37.8 38.8zm-6.4-9.8l-1.4-1.4 34.5-35.4 1.4 1.4-34.5 35.4zm-1.6-14.6l-1.4-1.4L577 64.9l1.4 1.4-21.6 22.2z"
                />
                <path
                  class="area"
                  d="M612.5,93c0-16.3-13.2-29.5-29.5-29.5S553.5,76.7,553.5,93s13.2,29.5,29.5,29.5S612.5,109.3,612.5,93z M583,118.5 c-14.1,0-25.5-11.4-25.5-25.5s11.4-25.5,25.5-25.5s25.5,11.4,25.5,25.5S597.1,118.5,583,118.5z M119.5,180.2v-8.8h466v-10h-17v-30 h-31v10h25v20h-30v-37h-6v37h-109v-43h-10v43h-110v-87h-10v87h-60v-4h-10v4h-98v-36h-7v36h-59v10h7v17h5v-17h44v8.8H119.5z M109.5,190.8v16.8h-44v-14h-5v14h-50v-36h30v-10h-30v-99h102v41h7v-41h98v79h10v-79h31v-10h-17v-42h49v42h-21v10h138v40h10v-40h109 v40h6v-40h81v99h-16v10h26v-119h-10h-313v-52h-69v52H0.5v165h119v-26.8H109.5z"
                />
              </svg>
            </li>
            <li>
              <h4>Datas</h4>
              <p>
                de <b>{{ thisShow.exposicao_start_date }}</b> a
                <b>{{ thisShow.exposicao_end_date }}</b>
              </p>
            </li>
            <li v-if="thisShow.exposicao_author">
              <h4>Autor</h4>
              <p>{{ thisShow.exposicao_author }}</p>
            </li>
            <li v-if="thisShow.exposicao_curadoria">
              <h4>Curador</h4>
              <p>{{ thisShow.exposicao_curadoria }}</p>
            </li>
            <li v-if="thisShow.exposicao_coordination">
              <h4>Coordenação</h4>
              <p>{{ thisShow.exposicao_coordination }}</p>
            </li>
            <li v-if="thisShow.exposicao_photography">
              <h4>Fotografia</h4>
              <p>{{ thisShow.exposicao_photography }}</p>
            </li>
            <li v-if="thisShow.exposicao_production">
              <h4>Produção</h4>
              <p>{{ thisShow.exposicao_production }}</p>
            </li>
            <li v-if="thisShow.exposicao_instalation">
              <h4>Montagem</h4>
              <p>{{ thisShow.exposicao_instalation }}</p>
            </li>
            <li v-if="thisShow.exposicao_pdf">
              <h4>Documento</h4>
              <p>
                <a v-bind:href="thisShow.exposicao_pdf.url" target="_blank">{{
                  thisShow.exposicao_pdf.title
                }}</a>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div id="exhibition-content">
      <div class="row align-center medium-collapse">
        <div
          class="xxlarge-10 medium-12 columns"
          v-html="thisShow.exposicao_content"
        ></div>

        <div
          class="xxlarge-10 medium-12 columns poetry-content"
          v-html="thisShow.exposicao_poetry"
        ></div>
      </div>
    </div>

    <gallery></gallery>
  </div>
</template>

<script>
import pageHeader from "../blocks/pageHeader";
import fixedHeader from "../blocks/fixedHeader";
import gallery from "../blocks/gallery";
import eventBus from "../../eventBus";

export default {
  name: "exhibition",
  data() {
    return {
      show: [],
      id: -1,
      slug: -1,
      loading: false
    };
  },
  components: {
    pageHeader: pageHeader,
    fixedHeader: fixedHeader,
    gallery: gallery
  },
  beforeMount() {},
  mounted() {
    this.slug = this.$route.params.slug;
    TweenMax.to("#exhibition", 2, {
      opacity: 1,
      delay: 0.5,
      ease: Power4.easeOut
    });
  },
  computed: {
    thisShow() {
      eventBus.$emit("hide-loader");
      return this.$store.getters.getShow(this.$route.params.slug);
    }
  }
};
</script>
<!-- styling for the component -->
<style lang="scss">
#exhibition {
  opacity: 0;

  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }

  #exhibition-header {
    margin-top: 120px;
    .category-link {
      @include responsive-font-size(18px);
      line-height: 1.1em;
      letter-spacing: 1px;

      &:after {
        height: 10px;
        bottom: 0;
      }

      &:hover {
        &:after {
          height: 100%;
        }
      }
    }

    h2 {
      @include responsive-font-size(70px);
      line-height: 1.1;
      margin-top: 40px;
    }

    h3 {
      @include responsive-font-size(20px);
      line-height: 1.5;
      margin-top: 15px;
      letter-spacing: -0.25px;
    }

    img {
      margin-top: 70px;
    }
  }

  #exhibition-info {
    .planta-svg {
      margin: 20px 0;
      width: 100%;
      height: auto;

      path:not(.area) {
        display: none;
      }
      .lab {
        fill: $green;
      }
      .q22 {
        fill: $yellow;
      }
      .grey {
        fill: #b5b5b5;
      }
      .ecras {
        fill: $red;
      }
    }
  }

  .technical-record {
    position: relative;
    margin-top: 60px;
    padding-top: 20px;

    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 5px;

      background-color: #000000;
    }
  }
  li {
    margin: 20px 0;
  }

  h3 {
    margin-top: 60px;
    @include responsive-font-size(30px);
  }

  h4 {
    margin-bottom: 6px;
    color: #b2b2b2;
  }
  h4,
  p {
    margin-top: 5px;
    font-family: "TT Norms";
    @include responsive-font-size(13px);
    text-transform: uppercase;
    line-height: 1.3;
  }

  #exhibition-content {
    position: relative;
    margin-top: 100px;
    margin-bottom: 100px;

    blockquote {
      font-family: "Libre Baskerville";
      @include responsive-font-size(40px);
      line-height: 1.5em;
      margin: 100px 200px 100px 100px;
    }

    p {
      font-family: "Libre Baskerville";
      @include responsive-font-size(16px);
      line-height: 1.5em;
      margin: 40px auto;
      max-width: 60%;
      text-transform: none;
    }

    .poetry-content {
      p {
        margin: 5px auto;
      }
    }

    h3 {
      @include responsive-font-size(40px);
      margin: 80px auto;
      text-align: center;
      max-width: 80%;
    }

    .aligncenter {
      display: block;
      margin: 0 auto;
      height: auto;
    }

    img {
      margin-top: 100px;
    }
    .double-image {
      display: inline-block;
      width: 40%;
      margin: 100px 4.9%;
    }
  }

  &.na {
    #exhibition-info {
      .planta-item {
        display: none;
      }
    }
  }
  &.q22 {
    #exhibition-info {
      .planta-svg {
        .q22 {
          display: block;
        }
      }
    }
  }
  &.lab {
    #exhibition-info {
      .planta-svg {
        .lab {
          display: block;
        }
      }
    }
  }
  &.gal-0 {
    #exhibition-info {
      .planta-svg {
        .ecras {
          display: block;
        }
      }
    }
  }
  &.sala-a {
    #exhibition-info {
      .planta-svg {
        .sala-a {
          display: block;
        }
      }
    }
  }
  &.sala-b {
    #exhibition-info {
      .planta-svg {
        .sala-b {
          display: block;
        }
      }
    }
  }
  &.sala-c {
    #exhibition-info {
      .planta-svg {
        .sala-c {
          display: block;
        }
      }
    }
  }
  &.sala-d {
    #exhibition-info {
      .planta-svg {
        .sala-d {
          display: block;
        }
      }
    }
  }
  &.sala-e {
    #exhibition-info {
      .planta-svg {
        .sala-e {
          display: block;
        }
      }
    }
  }
  &.sala-ab {
    #exhibition-info {
      .planta-svg {
        .sala-a {
          display: block;
        }
        .sala-b {
          display: block;
        }
      }
    }
  }
  &.sala-abc {
    #exhibition-info {
      .planta-svg {
        .sala-a {
          display: block;
        }
        .sala-b {
          display: block;
        }
        .sala-c {
          display: block;
        }
      }
    }
  }
  &.sala-abcd {
    #exhibition-info {
      .planta-svg {
        .sala-a {
          display: block;
        }
        .sala-b {
          display: block;
        }
        .sala-c {
          display: block;
        }
        .sala-d {
          display: block;
        }
      }
    }
  }
  &.sala-abcd-lc {
    #exhibition-info {
      .planta-svg {
        .sala-a {
          display: block;
        }
        .sala-b {
          display: block;
        }
        .sala-c {
          display: block;
        }
        .sala-d {
          display: block;
        }
        .lab {
          display: block;
        }
      }
    }
  }
  &.sala-bcd {
    #exhibition-info {
      .planta-svg {
        .sala-b {
          display: block;
        }
        .sala-c {
          display: block;
        }
        .sala-d {
          display: block;
        }
      }
    }
  }
  &.sala-cd {
    #exhibition-info {
      .planta-svg {
        .sala-c {
          display: block;
        }
        .sala-d {
          display: block;
        }
      }
    }
  }
}

body.mobile {
  #exhibition {
    #exhibition-header {
      .category-link {
        &:hover {
          &:after {
            height: 10px;
          }
        }
      }
    }
  }
}

@include max-screen($medium) {
  #exhibition {
    #exhibition-header {
      padding: 0 60px;
      margin-top: 120px;
    }

    #exhibition-info {
      padding: 0 60px;
    }
  }
}

@include max-screen($small) {
  #exhibition {
    #exhibition-header {
      padding: 0 30px;
    }

    #exhibition-info {
      padding: 0 30px;
    }

    #exhibition-content {
      margin: 80px 0;
      p {
        max-width: 80%;
      }
    }
  }
}

@include max-screen($xsmall) {
  #exhibition {
    h3 {
      margin-top: 40px;
    }

    .technical-record {
      margin-top: 40px;
      padding-bottom: 20px;

      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 5px;

        background-color: #000000;
      }
    }

    #exhibition-header {
      padding: 0 20px;
      margin-top: 80px;

      h2 {
        margin-top: 30px;
      }

      img {
        margin-top: 40px;
      }
    }

    #exhibition-info {
      padding: 0 20px;
    }

    #exhibition-content {
      margin: 60px 0 40px;
      padding: 0 20px;
      p {
        max-width: 100%;
      }
      h3 {
        max-width: 100%;
      }
    }
  }
}

@include max-screen($xxsmall) {
  #exhibition {
    #exhibition-header {
      margin-top: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Exhibition.vue